<template>
    <div id="kit-header">
      <div class="header-container">
        <div class="logo"></div>
        <div class="action-container">
          <a href="https://ee.kobotoolbox.org/x/#u1b3UVSL" target="_blank">
            <div class="report-button">
              <div class="icon-report"></div>{{$t('kit.reportingTool')}}
            </div>
          </a>
        </div>
      </div>
    </div>
</template>

<script>
import LanguageSelector from "./LanguageSelector";

export default {
  name: "kit-header-desktop",
  components: {LanguageSelector}
}
</script>

<style lang="stylus" scoped>
#kit-header
  width 100%
  display flex
  flex-direction row
  background #72E3C3
  .header-container
    display flex
    height 100px
    margin-left 10%
    margin-right 10%
    width 80%
    margin-top 20px
    margin-bottom 20px
    padding-bottom 20px
    flex-direction row
    align-items center
    border-bottom 1px solid #fff
    .logo
      width 300px
      min-height: 100px;
      background: url('~@/../static/images/kit-logo-white.svg') no-repeat left center;
    .action-container
      margin-left auto
      a
        color #ffffff
        text-decoration none 
        :visited
          color #ffffff
      .report-button
        background #48B199
        border-radius 6px
        padding 7px 15px
        min-height 25px
        color #ffffff
        cursor pointer
        display flex
        align-items center 
        .icon-report
           background: url('~@/../static/icons/reporting-white.svg') no-repeat center center;
           width 25px
           height 25px
           margin-right 10px


</style>



// WEBPACK FOOTER //
// src/components/KitHeaderDesktop.vue